import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Listbox } from 'primeng/listbox';
import { take } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { ReportService } from '../../../../../../services/report.service';
import { InputSubmitComponent } from '../../../../../../shared/components/input-submit/input-submit.component';
import { BaseResponseDto } from '../../../../../../types/dtos/base.dto';
import { InputSelectOptionInterface, InputSubmitInterface } from '../../../../../../types/interfaces/input.interface';
import {TranslateSafePipe} from '../../../../../../shared/pipes/translation.pipe';


@Component({
  selector: 'app-sigi-files',
  imports: [
    Listbox,
    ReactiveFormsModule,
    InputSubmitComponent,
    TranslateSafePipe,
  ],
  templateUrl: './sigi-files.html',
  styleUrl: './sigi-files.css',
})
export class SigiFiles implements OnInit {
  public loading: boolean = true;

  public sigiFiles: InputSelectOptionInterface[] = [];

  public sigiForm: FormGroup = new FormGroup({
    sigiFile: new FormControl(null, [
      Validators.required,
    ]),
  });

  public submitConfig: InputSubmitInterface = {
    formGroup: this.sigiForm,
    label: 'Download',
    iconName: 'download',
  };

  private readonly _sigiBasePath: string = environment.publicUrl + 'sigi/';

  constructor(
    private readonly _reportService: ReportService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  public ngOnInit(): void {
    this.loadSigiFiles();
  }

  public onSubmit(): void {
    const sigiFile: string | null = this.sigiForm.get('sigiFile')?.value ?? null;

    if (!sigiFile) {
      return;
    }

    this.downloadFile(sigiFile);
    this.sigiForm.reset();
  }

  private loadSigiFiles(): void {
    this.loading = true;

    this._reportService.getSigiFiles()
      .pipe(take(1))
      .subscribe({
        next: (result: BaseResponseDto<string[]>) => {
          this.sigiFiles = result.data
            ?.sort((firstFile: string, secondFile: string) =>
              secondFile.localeCompare(firstFile),
            )
            ?.map((file: string) => ({
              label: file,
              value: file,
            })) ?? [];

          this.loading = false;
          this._changeDetectorRef.detectChanges();
        },
        error: (error: unknown) => {
          console.error('Error fetching SigiFiles:', error);

          this.sigiFiles = [];
          this.loading = false;
          this._changeDetectorRef.detectChanges();
        },
      });
  }

  private downloadFile(fileName: string): void {
    const downloadUrl: string = `${ this._sigiBasePath }${ fileName }`;

    window.open(downloadUrl, '_blank');
  }
}
